import { z } from "zod";
import { LocalizedTextSchema, idPattern } from "./common.js";

export const AbilityFamilySchema = z.enum(["damage", "debuff", "defence", "support", "commander"]);
export type AbilityFamily = z.infer<typeof AbilityFamilySchema>;

export const AbilityKindSchema = z.enum(["standard", "active", "passive", "pulse", "ultimate", "aura", "protocol"]);
export type AbilityKind = z.infer<typeof AbilityKindSchema>;

export const AbilityTargetSchema = z.enum(["enemy", "enemies", "ally", "allies", "self", "rear", "none"]);
export type AbilityTarget = z.infer<typeof AbilityTargetSchema>;

export const ParamRangeSchema = z
  .object({ min: z.number(), max: z.number(), default: z.number() })
  .refine((r) => r.min <= r.default && r.default <= r.max, "default must lie within [min, max]");
export type ParamRange = z.infer<typeof ParamRangeSchema>;

export const ArchetypeDefSchema = z.object({
  id: idPattern("abl"),
  family: AbilityFamilySchema,
  kind: AbilityKindSchema,
  targets: AbilityTargetSchema,
  params: z.record(z.string(), ParamRangeSchema),
  /** Description template; `{param}` placeholders are replaced with the unit's parameter values. */
  text: LocalizedTextSchema,
});
export type ArchetypeDef = z.infer<typeof ArchetypeDefSchema>;

/** Targeting protocols a commander can carry (index used as `params.rule`). */
export const PROTOCOLS = [
  "front",
  "lowest_hp",
  "lowest_hp_pct",
  "highest_atk",
  "highest_def",
  "defender_first",
  "saboteur_first",
  "attacker_first",
  "random",
  "marked_first",
] as const;
export type Protocol = (typeof PROTOCOLS)[number];

/** Aura stat keys (index used as `params.stat`). */
export const AURA_STATS = ["atk", "def", "hp", "crit", "energy"] as const;
export type AuraStat = (typeof AURA_STATS)[number];
